import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITemplate, ITemplateInitialState } from "./templateModel";
import {
  ActiveInactiveTemplate,
  createTemplate,
  deleteTemplate,
  getAllActiveTemplates,
  getAllTemplates,
  getTemplateByID,
  updateTemplate,
} from "./services/template.services";

const initialState: ITemplateInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  TemplateList: [],
  TemplateID: null,
  TemplateDetail: {
    TemplateName: "",
    MetaApprovedTemplateName: "",
    TemplateDescription: "",
    LanguageCode: "",
    IsActive: 1,
  },
  FilterTemplate: {
    TemplateName: "",
    MetaApprovedTemplateName: "",
  },
};

const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    clearTemplateDetails: (state) => {
      state.TemplateDetail = initialState.TemplateDetail;
    },
    setTemplateID: (state, action) => {
      state.TemplateID = action.payload;
    },
    clearTemplateID: (state) => {
      state.TemplateID = initialState.TemplateID;
    },
    setFilterTemplate: (state, action) => {
      state.FilterTemplate = action.payload;
    },
    clearFilterTemplate: (state) => {
      state.FilterTemplate = initialState.FilterTemplate;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTemplates.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllTemplates.fulfilled,
      (state, action: PayloadAction<ITemplate[]>) => {
        state.loading = false;
        state.TemplateList = action.payload || [];
      }
    );
    builder.addCase(getAllTemplates.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TemplateList = [];
    });
    builder.addCase(createTemplate.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createTemplate.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createTemplate.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateTemplate.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateTemplate.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateTemplate.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteTemplate.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteTemplate.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteTemplate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getTemplateByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getTemplateByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.TemplateDetail = action.payload;
    });
    builder.addCase(getTemplateByID.rejected, (state, action) => {
      state.formLoading = false;
      state.TemplateDetail = initialState.TemplateDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveTemplates.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveTemplates.fulfilled,
      (state, action: PayloadAction<ITemplate[]>) => {
        state.loading = false;
        state.TemplateList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveTemplates.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TemplateList = [];
    });
    builder.addCase(ActiveInactiveTemplate.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveTemplate.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveTemplate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearTemplateDetails,
  clearTemplateID,
  setTemplateID,
  setFilterTemplate,
  clearFilterTemplate,
} = templateSlice.actions;
export default templateSlice.reducer;
